import React from 'react';

const Astronaut = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.9 38.72">
      <g id="astronaut">
        <g>
          <path
            d="M36.49,15.38l-2.1-.05a.58.58,0,0,0-.6.55,15.73,15.73,0,0,1-2.6,5.75L29,24.68M21.24,9.13a19.71,19.71,0,0,1-4.6.95c-3.14.34-4.85-.31-5.15-1.95a5.58,5.58,0,0,1,.35-3.7,14.49,14.49,0,0,1,1.55-2.15c.36-.73.2-1.18-.5-1.35L11.19.48m2.6,15.15L11.69,18q-2.36,2.36-3.5,1.9t-2.55-3l-2.25-4.2c-.6-1-1.17-1.21-1.7-.75l-1.3,1.6m22.9,11.1q-2.1-.84-5.55,1.3a10.41,10.41,0,0,0-3.55,4.35q-1.5,3.06-.65,4.2l.7.6,1.15.55"
            fill="none"
            stroke="#fff"
          />
          <path
            d="M23.44,9.23q2.25.75,3.55,4.1a34.7,34.7,0,0,1,1.65,6,18.83,18.83,0,0,1,.4,5.35l-5.55.3a29.92,29.92,0,0,0-4.2-5.45l-2.95-2.3-2.05-1.1q-1.15-.75,1.65-3.6,4.4-4.39,7.5-3.3"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            d="M29,24.68a18.83,18.83,0,0,0-.4-5.35,34.7,34.7,0,0,0-1.65-6q-1.3-3.35-3.55-4.1-3.11-1.1-7.5,3.3-2.8,2.85-1.65,3.6l2.05,1.1,2.95,2.3A29.92,29.92,0,0,1,23.49,25"
            fill="none"
            stroke="#383635"
          />
        </g>
        <g>
          <path
            d="M25,26.88q-1.95-1-.3-2.25a3.4,3.4,0,0,1,3.15-.85l4.5.1,3.75-.5.7-.4a6.35,6.35,0,0,0,1.35-1.85c.7-1.27,1.39-1.95,2.05-2.05l2.25.05a2.2,2.2,0,0,1,1.35,1.1l1.55,2.05c.24.6-.68.91-2.75.95-1.86,0-2.91.56-3.15,1.6l-.15.65a3.87,3.87,0,0,1-.8,1.9q-1.2.84-5.2-.6l-3.75-1.65L25,26.88"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            d="M29.56,25.13l3.75,1.65q4,1.44,5.2.6a3.87,3.87,0,0,0,.8-1.9l.15-.65c.24-1,1.29-1.57,3.15-1.6,2.07,0,3-.35,2.75-.95l-1.55-2.05a2.2,2.2,0,0,0-1.35-1.1l-2.25-.05c-.66.1-1.35.78-2.05,2.05A6.35,6.35,0,0,1,36.81,23l-.7.4-3.75.5-4.5-.1a3.4,3.4,0,0,0-3.15.85q-1.65,1.29.3,2.25"
            fill="none"
            stroke="#383635"
          />
        </g>
        <g>
          <path
            d="M20.46,32.29a6.91,6.91,0,0,1,1.25-5.35,6.52,6.52,0,0,1,4.6-2.9,6.66,6.66,0,0,1,5.3,1.15,6.79,6.79,0,0,1,3,4.65,6.71,6.71,0,0,1-1.2,5.3,6.82,6.82,0,0,1-4.65,3,6.55,6.55,0,0,1-5.3-1.2,6.69,6.69,0,0,1-2.95-4.6"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            d="M20.46,32.29a6.91,6.91,0,0,1,1.25-5.35,6.52,6.52,0,0,1,4.6-2.9,6.66,6.66,0,0,1,5.3,1.15,6.79,6.79,0,0,1,3,4.65,6.71,6.71,0,0,1-1.2,5.3,6.82,6.82,0,0,1-4.65,3,6.55,6.55,0,0,1-5.3-1.2A6.69,6.69,0,0,1,20.46,32.29Z"
            fill="none"
            stroke="#383635"
          />
          <path
            d="M22.76,30.19a4.41,4.41,0,0,1,3.6-5.05,4.08,4.08,0,0,1,3.3.75,4.2,4.2,0,0,1,1.75,2.8,4.13,4.13,0,0,1-.7,3.3,4.19,4.19,0,0,1-2.85,1.8,4.31,4.31,0,0,1-3.3-.75,4.49,4.49,0,0,1-1.8-2.85"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            d="M22.76,30.19a4.41,4.41,0,0,1,3.6-5.05,4.08,4.08,0,0,1,3.3.75,4.2,4.2,0,0,1,1.75,2.8,4.13,4.13,0,0,1-.7,3.3,4.19,4.19,0,0,1-2.85,1.8,4.31,4.31,0,0,1-3.3-.75A4.49,4.49,0,0,1,22.76,30.19Z"
            fill="none"
            stroke="#383635"
          />
          <path
            d="M31.26,28.09l-2.15,2.75q-2.59,2.6-4.85,1.95c-1.16-.3-1.26-1.08-.3-2.35s2.07-1.23,3.3,0a4.33,4.33,0,0,1,.15-2.35c.5-1.3,1.79-1.3,3.85,0"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            d="M31.26,28.09l-2.15,2.75q-2.59,2.6-4.85,1.95c-1.16-.3-1.26-1.08-.3-2.35s2.07-1.23,3.3,0a4.33,4.33,0,0,1,.15-2.35C27.91,26.79,29.2,26.79,31.26,28.09Z"
            fill="none"
            stroke="#383635"
          />
          <path
            d="M27.86,26.44l-3,1.25a1.41,1.41,0,0,1,1.55-1.5l1.45.25"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            d="M27.86,26.44l-1.45-.25a1.41,1.41,0,0,0-1.55,1.5"
            fill="none"
            stroke="#383635"
          />
        </g>
      </g>
    </svg>
  );
};

export default Astronaut;
